export default require("ethereum-blockies-base64");
